/** @format */
export const PlacementID = {
  FREQUENTLY_BOUGHT_TOGETHER: 'frequently-bought-together-high-diversity',
};
